import React from 'react'
import {
  LoadingWrapper,
  CardContainer,
  SvgContainer,
  LoadingText,
} from './style'

export interface OrdenoLoadingProps {
  text?: string | null | false
  size?: 'sm' | 'md' | 'lg'
  variant?: 'inline' | 'card' | 'overlay' | 'fullscreen'
  withCard?: boolean
  className?: string
  style?: React.CSSProperties
}

export const OrdenoLoading: React.FC<OrdenoLoadingProps> = ({
  text = 'Carregando...',
  size = 'md',
  variant = 'inline',
  withCard = false,
  className,
  style,
}) => {
  const content = (
    <>
      <SvgContainer $size={size} viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          className="bar-top"
          x="0"
          y="0"
          width="36"
          height="7.5"
          rx="3.75"
          fill="#72E38D"
        />
        <rect
          className="bar-middle"
          x="12"
          y="12"
          width="24"
          height="7.5"
          rx="3.75"
          fill="#FEFE84"
        />
        <rect
          className="bar-bottom"
          x="24"
          y="24"
          width="12"
          height="7.5"
          rx="3.75"
          fill="#FD7477"
        />
      </SvgContainer>
      {text && <LoadingText $size={size}>{text}</LoadingText>}
    </>
  )

  return (
    <LoadingWrapper
      $variant={variant}
      $size={size}
      className={className}
      style={style}
    >
      {withCard && variant !== 'card' ? (
        <CardContainer>{content}</CardContainer>
      ) : (
        content
      )}
    </LoadingWrapper>
  )
}

export default OrdenoLoading
